import type { FaireProductEntity } from "../../entity_types/product";

export const p_mv3avfvr6y: FaireProductEntity = {
  token: "p_mv3avfvr6y",
  type: "product",
  name: "Red Bandana Fringe Vest",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/4a562f545ee88c2e09c9ecbc7fe5b985503badc78931895df514e09d19a0fe16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14da0c49a035d85c636336a61ea4ea0d830b7266e99fcea12704b0e1bcb7b79b.jpeg",
    "https://cdn.faire.com/fastly/01ef3c450bcced93b5ec35d106a5ab2565ad3a1321aa0a250bff84439410bcea.jpeg",
    "https://cdn.faire.com/fastly/d6f4f54f14e766a0cfa3900c44cad2bfad1df514b7d5c4d0432b77e0114b188a.jpeg",
    "https://cdn.faire.com/fastly/d573e6cdaf88d8847b3d3114c042d23e1a1bb8939b4fbf369e17a606e22824fd.jpeg"
  ],
  priceDollars: 33.95,
  description: "Red Bandana Fringe Vest featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, sleeveless silhouette, and long fringe trim along the front and hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:45.295Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
